import React from 'react';
import HelpArticleLink from '../HelpArticleLink';

// Only two fixed display modes exist for v1 (server/helpers/pageLayout.js DISPLAY_MODES);
// unlike the five templates, this short, stable list is not worth a server round trip.
const DISPLAY_MODES = [
    {id: 'standard', label: 'Standard'},
    {id: 'takeover', label: 'Page Takeover'},
];

const TAKEOVER_WARNING = 'Page takeover mode removes the site sidebar and footer links so this '
    + 'page/post can use its own layout. Search meta, analytics, and cart scripts are kept. '
    + 'Continue?';

export default function DisplaySettingsSection({
    display,
    displayTemplates = [],
    onChangeDisplay,
}) {
    const mode = display?.mode || 'standard';
    const template = display?.template || 'classic';
    const applicableTemplates = displayTemplates
        .filter(candidate => (candidate.applicableModes || []).includes(mode));
    const changeMode = nextMode => {
        if (nextMode === mode) return;
        if (nextMode === 'takeover' && !window.confirm(TAKEOVER_WARNING)) return;
        const stillApplicable = displayTemplates
            .find(candidate => candidate.id === template
                && (candidate.applicableModes || []).includes(nextMode));
        onChangeDisplay?.({
            mode: nextMode,
            template: stillApplicable ? template : 'classic',
        });
    };

    const changeTemplate = nextTemplate => {
        if (nextTemplate === template) return;
        onChangeDisplay?.({mode, template: nextTemplate});
    };

    return <section className="content-editor-panel" aria-labelledby="display-settings-title">
        <header className="content-editor-panel-header">
            <div>
                <h2 id="display-settings-title">Layout</h2>
                <p className="help">Choose the page chrome and content structure.</p>
            </div>
            <HelpArticleLink slug="page-and-blog-layouts" variant="link" label="Help with page and blog layouts" />
        </header>

        <div role="radiogroup" aria-label="Display mode" className="content-display-mode-toggle">
            {DISPLAY_MODES.map(option => <button
                key={option.id}
                type="button"
                role="radio"
                aria-checked={mode === option.id}
                className={`content-display-mode-option${mode === option.id ? ' selected' : ''}`}
                onClick={() => changeMode(option.id)}
            >{option.label}</button>)}
        </div>

        <div className="content-display-template-grid">
            {applicableTemplates.map(candidate => <button
                key={candidate.id}
                type="button"
                aria-pressed={template === candidate.id}
                className={`content-display-template-card${
                    template === candidate.id ? ' selected' : ''}`}
                onClick={() => changeTemplate(candidate.id)}
            >
                <span>{candidate.label}</span>
            </button>)}
        </div>

    </section>;
}
